import HttpFactory from '~/api/http-factory'

export default class BackInStockNotifications extends HttpFactory {
  private readonly resource = 'v1/backInStockNotifications'

  public createBackInStockNotification (data: object) {
    return this.$fetch(this.resource, { method: 'POST', body: JSON.stringify(data) })
  }
}
